const Constants = {
  HH_COMPONENTS_URL: process.env.VUE_APP_HH_COMPONENTS_URL,
  ACCESS_DASHBOARD_URL: process.env.VUE_APP_ACCESS_DASHBOARD,
  COMPONENT_ENV: process.env.VUE_APP_COMPONENT_ENV,
  LANDING_PAGE_URL: process.env.VUE_APP_LANDING_PAGE_URL,
  APP_LIST: [
    {
      title: "Autodesk One",
      logo: require("@/assets/images/Autodesk_logo_circle.svg"),
      url: process.env.VUE_APP_AUTODESK_ONE,
      description: "Autodesk’s intranet with news and resources for workers"
    },
    {
      title: "Engineer's Home Page",
      logo: require("@/assets/images/EngineersHomepage.svg"),
      url: "https://engineering.autodesk.com",
      description: "The central connection point for the Autodesk Engineering community"
    },
    {
      title: "Password management",
      logo: require("@/assets/images/Password_management.svg"),
      fn: "openChangePwdModal",
      description: "Change, update, or reset your Autodesk password"
    },

    {
      title: "Two-step verification",
      logo: require("@/assets/images/Two-step_verification.svg"),
      url: process.env.VUE_APP_TWO_STEP_VERIFICATION,
      description: "Set up Microsoft Authenticator to access Autodesk applications"
    },
    {
      title: "Facilities request",
      logo: require("@/assets/images/Facilities_request.svg"),
      url: "https://autodesk.ops.bim360ops.com",
      description: "Submit a facilities request using BIM 360 Ops"
    },
    {
      title: "All applications",
      logo: require("@/assets/images/Autodesk_logo_circle.svg"),
      url: process.env.VUE_APP_ACCESS_DASHBOARD,
      description: "One place to serve all your application and access related needs"
    }
  ]
};

export default Constants;